module.exports = !require(64) && !require(69)(function () {
  return Object.defineProperty(require(65)('div'), 'a', { get: function () { return 7; } }).a != 7;
});
